import moment from 'moment';

export const STATUS_COLOR = {
  PAID: 'paid',
  SENT_TO_BANK: 'sent',
  AWAITING_PAYMENT: 'awaiting',
  PROCESSING: 'processing',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  REFUND: 'refund',
  REFUND_REQUESTED: 'refund-requested',
  REFUND_PROCESSING: 'refund-processing',
  REFUND_TO_WALLET: 'refund-wallet',
  RETURNED: 'returned',
  UPCOMING: 'upcoming',
  SCHEDULED: 'scheduled'
};

export const TRANSACTION_FILTER_STATUS_CRITERIA = {
  status: [
    {
      status_code: 'PAID',
      text: 'Paid'
    },
    {
      status_code: 'SENT_TO_BANK',
      text: 'Sent'
    },
    {
      status_code: 'AWAITING_PAYMENT',
      text: 'Awaiting'
    },
    {
      status_code: 'PROCESSING',
      text: 'Processing'
    },
    {
      status_code: 'FAILED',
      text: 'Failed'
    },
    {
      status_code: 'CANCELLED',
      text: 'Cancelled'
    }
  ],
  returns: [
    {
      status_code: 'REFUND',
      text: 'Refund'
    },
    {
      status_code: 'REFUND_REQUESTED',
      text: 'Refund Requested'
    },
    {
      status_code: 'REFUND_PROCESSING',
      text: 'Refund Processing'
    },
    {
      status_code: 'REFUND_TO_WALLET',
      text: 'Refund To Wallet'
    },
    {
      status_code: 'RETURNED',
      text: 'Returned'
    }
  ]
};

function getLastEpoch(type) {
  return () => moment().startOf(type);
}

function getSecondLastEpoch(type) {
  return () => {
    let last = moment().startOf(type);
    last.subtract(1, type);
    return last;
  };
}

export const TRANSACTION_FILTER_DATE_CRITERIA = [
  {
    label: 'This week',
    className: 'this-week',
    from: getLastEpoch('week'),
    to: moment
  },
  {
    label: 'This month',
    className: 'this-month',
    from: getLastEpoch('month'),
    to: moment
  },
  {
    label: 'This year',
    className: 'this-year',
    from: getLastEpoch('year'),
    to: moment
  },
  {
    label: 'Last week',
    className: 'last-week',
    from: getSecondLastEpoch('week'),
    to: getLastEpoch('week')
  },
  {
    label: 'Last month',
    className: 'last-month',
    from: getSecondLastEpoch('month'),
    to: getLastEpoch('month')
  },
  {
    label: 'Last year',
    className: 'last-year',
    from: getSecondLastEpoch('year'),
    to: getLastEpoch('year')
  }
];
